import logo from './icons/logo.svg'
import logoWhite from './icons/logo-white.svg'

const icons = {
  logo,
  logoWhite,
}

export default icons
